class BaseManager {
  _prismicManager;
  constructor(prismicManager) {
    this._prismicManager = prismicManager;
  }
  get prismicAuthManager() {
    return this._prismicManager.getPrismicAuthManager();
  }
  get pluginSystemRunner() {
    return this._prismicManager.getPluginSystemRunner();
  }
  set pluginSystemRunner(pluginSystemRunner) {
    this._prismicManager._pluginSystemRunner = pluginSystemRunner;
  }
  get cwd() {
    return this._prismicManager.cwd;
  }
  // Protected instance prevents circular intellisense
  // e.g. prismicManager.user.user.user
  get user() {
    return this._prismicManager.user;
  }
  get prismicRepository() {
    return this._prismicManager.prismicRepository;
  }
  get plugins() {
    return this._prismicManager.plugins;
  }
  get project() {
    return this._prismicManager.project;
  }
  get customTypes() {
    return this._prismicManager.customTypes;
  }
  get slices() {
    return this._prismicManager.slices;
  }
  get versions() {
    return this._prismicManager.versions;
  }
  get telemetry() {
    return this._prismicManager.telemetry;
  }
}
export {
  BaseManager
};
//# sourceMappingURL=BaseManager.js.map
